module.exports = __webpack_public_path__ + "img/src/components/ContactForm/callLogo.svg?7c2dc9c5";